import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { AdminStats } from '../../models/adminStats';
import { SchedulePeriod } from '../../models/schedulePeriod';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseChartDirective  } from 'ng2-charts';
import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';

@Component({
  selector: 'app-dashboard',
  imports: [RouterModule, FormsModule, CommonModule, BaseChartDirective ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  stats: AdminStats | undefined;
  recentSchedulePeriods: SchedulePeriod[] = [];

  knowledgeBaseOrgLabels: any[] = [];
  knowledgeBaseOrgDatasets: any[] =[];
  knowledgeBaseOrgOptions: any = {
    plugins: {
      legend: {
        display: true,
        position: 'top',
      }
    }
  }

  constructor(private adminService: AdminService) { }

  ngOnInit(): void {
    this.loadAdminData();
  }

  loadAdminData() {

    // Fetch aggregated stats
    this.adminService.getAdminStats().subscribe(stats => {
      this.stats = stats;
    });

    // Fetch recent schedule periods (paginated)
    this.adminService.getRecentSchedulePeriods(10).subscribe(periods => {
      this.recentSchedulePeriods = periods;
    });

    // Fetch pie chart data
    this.adminService.getKnowledgeBaseByOrganization().subscribe(data => {      
      this.knowledgeBaseOrgLabels = data.map(d => d.organizationName);
      this.knowledgeBaseOrgDatasets = [{
        label: 'Knowledge Base Items',
        data: data.map(d => d.value),
        borderColor: '#A9A9A9',
        borderSkipped: false,
        backgroundColor: '#AEE3E3',
        hoverOffset: 4
      }];
    });

  }

  private getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }


  viewPeriod(periodId: string) {
    // Navigate to period details or show modal
    console.log(`View period: ${periodId}`);
  }

}
